import React, { FC } from 'react';
import styled from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import { Icon } from '@cld/icon';
import { typography } from '@cld/typography';

const Root = styled.div`
  display: flex;
  ${typography.xxs.regular};

  ${Icon} {
    margin-right: ${globalTheme.spacing.xxs};
  }
`;

export interface InfoLineProps {
  text: string;
}

export const InfoLine: FC<InfoLineProps> = ({ text, ...rest }) => (
  <Root {...rest}>
    <Icon name="infoOutline" size="sm" />
    {text}
  </Root>
);
